export const REST_API_ENDPOINT: string = process.env.NEXT_PUBLIC_REST_API_ENDPOINT || "";
export const LOGIN_REDIRECT_URL: string = "/app/home";
// Where a multi-org user lands after verifying: the second way into the app,
// alongside LOGIN_REDIRECT_URL. The backend picks between them by membership
// count, so both are post-login destinations rather than one being a detour.
// It names this route too (SELECT_ORGANIZATION_REDIRECT_URL in Django
// settings), and the two have to agree. Drift is not silent-dangerous: an
// unrecognized destination just loses the deep link and lands on the app home.
export const SELECT_ORGANIZATION_URL: string = "/auth/select-organization";

// Layout dimensions shared across AppShell header, nav, and chat aside
export const HEADER_HEIGHT = 60;
export const ONBOARDING_REDIRECT_URL: string = "/app/settings/users";

export const PAGE_SIZES = [10, 25, 100];

export const FREQUENCY_INTERVALS = {
  AS_NECESSARY: { value: "as_necessary", label: "As Necessary" },
  DAILY: { value: "daily", label: "Daily" },
  WEEKLY: { value: "weekly", label: "Weekly" },
  BI_WEEKLY: { value: "bi_weekly", label: "Bi-Weekly" },
  MONTHLY: { value: "monthly", label: "Monthly" },
  BI_MONTHLY: { value: "bi_monthly", label: "Bi-Monthly" },
  QUARTERLY: { value: "quarterly", label: "Quarterly" },
  SEMI_ANNUALLY: { value: "semi_annually", label: "Semi-Annually" },
  ANNUALLY: { value: "annually", label: "Annually" },
  BI_ANNUALLY: { value: "bi_annually", label: "Bi-Annually" },
};

export const ORG_MEMBERSHIP_STATUS = {
  added: "added",
  invited: "invited",
  active: "active",
  removed: "removed",
};

export const ORG_MEMBERSHIP_STATUS_OPTIONS = [
  {
    value: ORG_MEMBERSHIP_STATUS.added,
    label: "Added",
  },
  {
    value: ORG_MEMBERSHIP_STATUS.invited,
    label: "Invited",
  },
  {
    value: ORG_MEMBERSHIP_STATUS.active,
    label: "Active",
  },
  {
    value: ORG_MEMBERSHIP_STATUS.removed,
    label: "Removed",
  },
];

export const ORG_MEMBERSHIP_TYPE = {
  consultant: "consultant",
  employee: "employee",
};

export const PERMISSION_PROFILE = {
  admin: "permission_profile_admin",
  user: "permission_profile_user",
};

export const HIERARCHY_RELATIONSHIP = {
  self: "self",
  parent: "parent",
  ancestor: "ancestor",
  sibling: "sibling",
  child: "child",
  descendant: "descendant",
};

export const PENDING_USER_STATUS = {
  pending: "pending",
  converted: "converted",
  dismissed: "dismissed",
};

export const PENDING_USER_STATUS_OPTIONS = [
  {
    value: PENDING_USER_STATUS.pending,
    label: "Pending Review",
  },
  {
    value: PENDING_USER_STATUS.converted,
    label: "Converted to User",
  },
  {
    value: PENDING_USER_STATUS.dismissed,
    label: "Dismissed",
  },
];

export const PENDING_DECISION_PARTICIPANT_STATUS = {
  pending: "pending",
  accepted: "accepted",
  dismissed: "dismissed",
};

export const PENDING_USER_ACTIONS = {
  add_and_invite: "add_and_invite",
  add: "add",
  dismiss: "dismiss",
};

export const PENDING_USER_ACTION_OPTIONS = [
  {
    value: PENDING_USER_ACTIONS.add_and_invite,
    label: "Add and Invite",
  },
  {
    value: PENDING_USER_ACTIONS.add,
    label: "Add",
  },
  {
    value: PENDING_USER_ACTIONS.dismiss,
    label: "Dismiss",
  },
];

export const PENDING_DECISION_PARTICIPANT_ACTIONS = {
  add_and_invite: "add_and_invite",
  dismiss: "dismiss",
};

export const PENDING_DECISION_PARTICIPANT_ACTION_OPTIONS = [
  {
    value: PENDING_DECISION_PARTICIPANT_ACTIONS.add_and_invite,
    label: "Add & Invite",
  },
  {
    value: PENDING_DECISION_PARTICIPANT_ACTIONS.dismiss,
    label: "Dismiss",
  },
];
